var lx = lx || {};
/*File related functions*/
lx.conn = lx.conn || {};

lx.conn.resp = function (pId, pResp, pThis, pRefresh, pMsg, pConfirm){
	if (pResp == 'C' && !pConfirm){
		var dialogDiv = lx.dialog.alertMsg({type: "warning", msg: lx.tran.get("CANCEL_CONNECTION_REQ")});
		var lButtons = [];
		lButtons.push({label: lx.tran.get('APEX.DIALOG.OK'), js: "lx.conn.resp("+pId+", '"+pResp+"', '#BtnCncl', "+pRefresh+", "+pMsg+", true);", class: "t-Button--primary", fa:'far fawe-check'});	
		lButtons.push({label: lx.tran.get("CANCEL_BTN"), js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});	
		lx.dialog.open({ id: "CancelResp", html: dialogDiv, maxWidth: "690px", buttons: lButtons});
		return;
	}
    lx.load.add();
    apex.server.process("connReqResp", {
                    x01: pId,
                    x02: pResp,
                    x03: $(".feed-conn-msg").val() //""//Message
                }, {dataType: 'json',
                    success: function (d) {
                        lx.load.remove();
		                if (pResp == 'C') {
							$('.lxpDialog').css('display','none');
							$('#BtnReqSry').css('display','none'); // in page 51
						}
						if (pRefresh=='N' || pRefresh==null) {
                            if (d.success) {
                                if ($(pThis).closest(".feed-post").length > 0) lx.feed.notifyRefresh(pThis, d.ety, d.pid);
								else if ($(pThis).closest(".profileStripeMembership").length > 0) location.reload();
                                else $(pThis).closest(".t-Button").replaceWith(d.btn);
                            } else lx.info.error(d.err);
						}
                    }
                });
	if (pRefresh=='Y') {
		setTimeout(function(){location.reload();}, 1000);		
	}
	lx.load.remove();
}

lx.conn.empHandle = function (pId, pAction, pThis){
    lx.load.add();
	apex.server.process("conEmpHandle", {
						x01: pId,
						x02: pAction
					}, {dataType: 'json',
						success: function (d) {
							lx.load.remove();
							if (d.success) {
								if ($(pThis).parent().hasClass("lxIrIcons")) {
									try{ apex.region("empConnMe").refresh(); } catch(err){console.log(err);}
									try{ apex.region("empConn").refresh(); } catch(err){console.log(err);}
								} else {
									$(pThis).closest(".t-Button").replaceWith(d.btn);
								}
							}
							else lx.info.error(d.err);
						}
				});
		
};

lx.conn.connDisconnect = function (pId, pThis, pWarning, pAction){
	if (pWarning) {
		var lButtons = [];
		var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--info t-Alert" style="margin-bottom:0rem;"><div class="t-Alert-wrap" style="display: block;text-align: center;"><div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon" style="font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div><div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">' + lx.tran.get("HOW_TO_PROCEED") + '</div></div></div>';
		lButtons.push({label: lx.tran.get("DISCONNECT"), id: "idDiscBtn", js: "lx.conn.connDisconnect("+pId+",'#N"+pId+"D');", fa:'fas fawe-handshake-slash', class:'t-Button--primary'});
		lButtons.push({label: lx.tran.get("DISCONNECT_ARCHIVE"), id: "idDiscBtn", js: "lx.conn.connDisconnect("+pId+",'#N"+pId+"D',null,'ARCHIVE');", fa:'fas fawe-handshake-slash', class:'t-Button--primary'});
		if (!pAction) {
		  lButtons.push({label: lx.tran.get("DISCONNECT_DELETE"), id: "idDiscBtn", js: "lx.conn.connDisconnect("+pId+",'#N"+pId+"D',null,'DELETE');", fa:'fas fawe-handshake-slash', class:'t-Button--primary'});
		}
		lButtons.push({label: lx.tran.get("CANCEL_BTN"), id: "idCoseBtn", js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});
		lx.dialog.open({id:"DiscConn", maxWidth: "690px", html: dialogDiv,  buttons: lButtons});
	} else {
		lx.load.add();  
		apex.server.process("connDisconnect", {
						x01: pId,
						x02: pAction
					}, {dataType: 'json',
						success: function (d) {
							lx.load.remove();
							if (d.success) {
								if ($(pThis).parent().hasClass("lxIrIcons")) {
									try{ apex.region("empConnMe").refresh(); } catch(err){console.log(err);}
									try{ apex.region("empConn").refresh(); } catch(err){console.log(err);}
								} else {
									$(pThis).closest(".t-Button").replaceWith(d.btn);
								}
							}
							else lx.info.error(d.err);
						}
					});
		$('.lxpDialog').css('display','none');			
	};				
};

lx.conn.syncInfo = (pCnct, pCnctId, pCallback, pContainer) => {
    lx.load.add();
    apex.server.process("syncInfo", {
                    x01: pCnct,
                    x02: pCnctId
                }, {dataType: 'json',
                    success: (d) => {
                        lx.load.remove();
                        if (d.success) {
                            if (pContainer){
                                $(pContainer).html( '<div class="syncInfoInline"><div class="msg">'+ d.info +
                                                    '</div><div class="list">'+ d.list.join(', ') +
                                                    '</div></div>');
                            } else {
                                let lButtons = [];
								if (d.apprLink) {
									lButtons.push({label: d.btnLabelApprovals, id: "btnSyncApproval", link: d.apprLink});
								}
                                lButtons.push({label: 'Ok', id: "btnSyncShare", js: "setTimeout(()=>{lxpDialog.close(this);},1);", class:'t-Button--primary', fa:'far fawe-check'});
                                lButtons.push({label: d.btnLabelCancel, id: "noShare", js: "lxpDialog.close(this);", fa:'far fawe-times'});
                                let list = "";
                                for (let i = 0; i < d.list.length; i++) {
                                    list += '<li>'+ d.list[i] +'</li>';
                                }
								
								
								var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--info t-Alert" style="margin-bottom:0rem;">'
								               + '<div class="t-Alert-wrap" style="display: block;text-align: center;"><div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon" style="font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div><div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">'
											   + '<div class="syncInfoContact">'+
                                                    '<div class="msg">' + d.info + '</div>'+
                                                    '<ul class="list">' + d.list.join(', ') + '</ul>'+
                                                    /*'<div class="btns">' + lx.btn.genAll(lButtons) + '</div>'+*/
                                                   '</div>'
											   + '</div></div></div>';
                               /* let dialogDiv = '<div class="content">'+
                                                    '<div class="msg">' + d.info + '</div>'+
                                                    '<ul class="list">' + list + '</ul>'+
                                                    '<div class="btns">' + lx.btn.genAll(lButtons) + '</div>'+
                                                '</div>';*/
                                lx.dialog.open({id:"syncInfo", maxWidth: "690px", title: null, html: dialogDiv, buttons: lButtons});
                                $("#btnSyncShare").click(pCallback);
                            }
                        } else lx.info.error(d.err);
                    }
                });
}

/*ex showMemberships function*/
var lxSubDialog, lxSubDialogVals;
lx.conn.loadSubs = function (pProfileId, pMode, pBtnType, pSingle) {
    var vWidth = 464;
    lxSubDialogVals = { profileId: pProfileId, mode: pMode, btnType: pBtnType, single: pSingle };
    if (pSingle) vWidth = 464;
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getAjax",
            x01: "SUB",
            x02: pProfileId,
            x03: "0:" + pMode + ":" + pBtnType
        },
        success: function (d) {
            if (lxSubDialog) if (lxSubDialog.dialog('isOpen')) lxSubDialog.dialog("close");
            lxSubDialog = $(d).dialog({
                width: vWidth,
                modal: true,
				title: "Memberships"
            });
        }
    });
};